import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";

const initState = {
  order: [],
  waiterOrders: [],
  updatedOrder: {},
  originalOrder: {},
  allOrder: [],
  OrdersRestData: [],
  totalAmount: 0,
  refundLoading: false,
  Loader: false,
};
const orderReducer = (state = initState, action) => {
  const calculateTotalPrice = (item) => {
    const addonsTotal = (item.addons || []).reduce(
      (sum, addon) => sum + addon.price * addon.quantity,
      0
    );
    return item.price * item.quantity + addonsTotal;
  };
  switch (action.type) {
    case "GET_ORDER_BY_ID":
      return {
        ...state,
        order: action.payload,
      };
    case "GET_ALL_ORDERS":
      return {
        ...state,
        allOrder: action.payload,
      };
    case "ORDERS_LOADER":
      return {
        ...state,
        Loader: action.payload,
      };
    case "CLEAR_TABLE_STATE":
      if (state.updatedOrder?.id === action.payload) {
        return {
          ...state,
          updatedOrder: {},
        };
      }
      return state;
    case "REFUND_LOADER":
      return {
        ...state,
        refundLoading: action.payload,
      };
    case "SET_WAITER_ORDERS":
      return {
        ...state,
        waiterOrders: action.payload,
      };
    case "ADD_ITEM_TO_ORDER": {
      const newItem = action.payload;
      const existingOrder = [...state.updatedOrder.order];

      let itemMatched = false;

      const updatedOrder = existingOrder.map((orderItem) => {
        if (itemMatched) return orderItem;

        // MATCH LOGIC for "item"
        if (newItem.type === "item") {
          const sameItem =
            orderItem.id === newItem.id &&
            orderItem.size === newItem.size &&
            Number(orderItem.price) === Number(newItem.price);

          if (sameItem) {
            itemMatched = true;
            return {
              ...orderItem,
              quantity: orderItem.quantity + (newItem.quantity || 1),
              totalPrice:
                (orderItem.quantity + (newItem.quantity || 1)) *
                parseFloat(orderItem.price),
            };
          }
        }

        // MATCH LOGIC for "offer"
        if (newItem.type === "offer") {
          const sameOffer =
            orderItem.type === "offer" && orderItem.id === newItem.id;

          if (sameOffer) {
            itemMatched = true;
            return {
              ...orderItem,
              quantity: orderItem.quantity + (newItem.quantity || 1),
              totalPrice:
                (orderItem.quantity + (newItem.quantity || 1)) *
                parseFloat(orderItem.price),
            };
          }
        }

        return orderItem;
      });

      // If no match found, add as new item with orderItemID
      if (!itemMatched) {
        newItem.orderItemID = uuidv4();
        updatedOrder.push({ ...newItem, quantity: 1 });
      }

      return {
        ...state,
        updatedOrder: {
          ...state.updatedOrder,
          order: updatedOrder,
        },
      };
    }
    case "SET_TO_ORDER":
      return {
        ...state,
        updatedOrder: action.payload,
        originalOrder: action.payload,
      };
    case "INCREMENT_ITEM_QUANTITY": {
      const newOrder = state.updatedOrder.order.map((item) =>
        item.orderItemID === action.payload
          ? {
              ...item,
              quantity: item.quantity + 1,
              totalPrice: calculateTotalPrice({
                ...item,
                quantity: item.quantity + 1,
              }),
            }
          : item
      );
      return {
        ...state,
        updatedOrder: {
          ...state.updatedOrder,
          order: newOrder,
        },
      };
    }

    case "DECREMENT_ITEM_QUANTITY": {
      let newOrder = state.updatedOrder.order
        .map((item) =>
          item.orderItemID === action.payload
            ? {
                ...item,
                quantity: item.quantity - 1,
                totalPrice: calculateTotalPrice({
                  ...item,
                  quantity: item.quantity - 1,
                }),
              }
            : item
        )
        .filter((item) => item.quantity > 0); // Remove if qty hits 0

      return {
        ...state,
        updatedOrder: {
          ...state.updatedOrder,
          order: newOrder,
        },
      };
    }

    case "ADD_OR_UPDATE_NEW_ADDON": {
      const { orderItemID, addon } = action.payload;

      const updatedOrderItems = state.updatedOrder.order.map((item) => {
        if (item.orderItemID === orderItemID) {
          const addons = item.addons || [];

          const existingIndex = addons.findIndex((a) => a.id === addon.id);

          let updatedAddons;
          if (existingIndex !== -1) {
            //Update quantity
            updatedAddons = [...addons];
            updatedAddons[existingIndex] = {
              ...updatedAddons[existingIndex],
              quantity: (updatedAddons[existingIndex].quantity || 0) + 1,
            };
          } else {
            //Add new addon with default quantity
            updatedAddons = [
              ...addons,
              {
                id: addon.id,
                name: addon.name,
                price: addon.price,
                quantity: 1,
              },
            ];
            toast.success("Addon added successfully");
          }

          return {
            ...item,
            addons: updatedAddons,
            totalPrice: calculateTotalPrice({ ...item, addons: updatedAddons }),
          };
        }
        return item;
      });

      return {
        ...state,
        updatedOrder: {
          ...state.updatedOrder,
          order: updatedOrderItems,
        },
      };
    }

    case "INCREMENT_ADDON_QUANTITY": {
      const { orderItemID, addonID } = action.payload;
      const updatedOrderItems = state.updatedOrder.order.map((item) => {
        if (item.orderItemID === orderItemID) {
          const updatedAddons = item.addons.map((addon) => {
            if (addon.id === addonID) {
              return { ...addon, quantity: addon.quantity + 1 };
            }
            return addon;
          });
          return {
            ...item,
            addons: updatedAddons,
            totalPrice: calculateTotalPrice({
              ...item,
              addons: updatedAddons,
            }),
          };
        }
        return item;
      });

      return {
        ...state,
        updatedOrder: {
          ...state.updatedOrder,
          order: updatedOrderItems,
        },
      };
    }

    case "DECREMENT_ADDON_QUANTITY": {
      const { orderItemID, addonID } = action.payload;
      const updatedOrderItems = state.updatedOrder.order.map((item) => {
        if (item.orderItemID === orderItemID) {
          const updatedAddons = item.addons
            .map((addon) => {
              if (addon.id === addonID) {
                if (addon.quantity > 1) {
                  return { ...addon, quantity: addon.quantity - 1 };
                }
                return null; // remove if quantity 1
              }
              return addon;
            })
            .filter(Boolean); // remove nulls
          return {
            ...item,
            addons: updatedAddons,
            totalPrice: calculateTotalPrice({
              ...item,
              addons: updatedAddons,
            }),
          };
        }
        return item;
      });
      return {
        ...state,
        updatedOrder: {
          ...state.updatedOrder,
          order: updatedOrderItems,
        },
      };
    }

    case "REMOVE_ITEM": {
      const itemToRemoveId = action.payload; // should be orderItemID
      const filteredOrder = state.updatedOrder.order.filter(
        (item) => item.orderItemID !== itemToRemoveId
      );

      return {
        ...state,
        updatedOrder: {
          ...state.updatedOrder,
          order: filteredOrder,
        },
      };
    }

    case "EMPTY_ORDER":
      return {
        ...state,
        updatedOrder: {},
      };

    case "GET_ALL_REST_ORDERS":
      return {
        ...state,
        OrdersRestData: action.payload,
      };
    case "SET_TOTAL_AMOUNT":
      return {
        ...state,
        totalAmount: action.payload,
      };
    case "UPDATE_ORDER_ITEM_NOTES": {
      const { orderItemID, notes } = action.payload;
      const updatedOrderItems = state.updatedOrder.order.map((item) => {
        if (item.orderItemID === orderItemID) {
          return { ...item, notes };
        }
        return item;
      });
      return {
        ...state,
        updatedOrder: {
          ...state.updatedOrder,
          order: updatedOrderItems,
        },
      };
    }
    default:
      return {
        ...state,
      };
  }
};
export default orderReducer;
